import {
  PRODUCTOPTIONDETAIL_LOADING,
  GET_PRODUCTOPTIONDETAIL,
  GET_PRODUCTOPTIONDETAIL_SUCCESS,
  GET_PRODUCTOPTIONDETAIL_FAIL,
  ADD_PRODUCTOPTIONDETAIL_SUCCESS,
  ADD_PRODUCTOPTIONDETAIL_FAIL,
  DELETE_PRODUCTOPTIONDETAIL_SUCCESS,
  DELETE_PRODUCTOPTIONDETAIL_FAIL,
  UPDATE_PRODUCTOPTIONDETAIL_SUCCESS,
  UPDATE_PRODUCTOPTIONDETAIL_FAIL,
  PRODUCTOPTIONDETAIL_RESET
} from "./actionType";

const INIT_STATE = {
  productOptionDetails: [],
  error: {},
};

const ProductOptionDetail = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTOPTIONDETAIL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PRODUCTOPTIONDETAIL:
          return {
            ...state,
            productOptionDetails: action.payload.data,
            isProductOptionDetailCreated: false,
            isProductOptionDetailSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PRODUCTOPTIONDETAIL_FAIL:
      switch (action.payload.actionType) {
        case GET_PRODUCTOPTIONDETAIL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isProductOptionDetailCreated: false,
            isProductOptionDetailSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PRODUCTOPTIONDETAIL: {
      return {
        ...state,
        isProductOptionDetailCreated: false,
        loading: true,
      };
    }

    case PRODUCTOPTIONDETAIL_LOADING: {
      return {
        ...state,
        isProductOptionDetailCreated: false,
        loading: true,
      };
    }

    case ADD_PRODUCTOPTIONDETAIL_SUCCESS:
      return {
        ...state,
        isProductOptionDetailCreated: true,
        loading: false,
        productOptionDetails: [action.payload.data, ...state.productOptionDetails],
      };

    case ADD_PRODUCTOPTIONDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRODUCTOPTIONDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isProductOptionDetailCreated: true,
        productOptionDetails: state.productOptionDetails.filter(
          productOptionDetail => productOptionDetail.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PRODUCTOPTIONDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PRODUCTOPTIONDETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        isProductOptionDetailCreated: true,
        productOptionDetails: state.productOptionDetails.map(productOptionDetail =>
          productOptionDetail.id.toString() === action.payload.data.id.toString() ? { ...productOptionDetail, ...action.payload.data } : productOptionDetail
        ),
      };

    case UPDATE_PRODUCTOPTIONDETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRODUCTOPTIONDETAIL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ProductOptionDetail;